import React from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

const PageContainer = styled.div`
  min-height: 100vh;
  background: #0B1122;
  color: white;
  padding: 2.5rem;
`;

const BackButton = styled.button`
  font-size: 0.875rem;
  color: #5ce9ff;
  background: none;
  border: none;
  cursor: pointer;
  margin-bottom: 1.5rem;
  padding: 0;
  
  &:hover {
    text-decoration: underline;
  }
`;

const ProductGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  margin-top: 1.5rem;
  
  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const ProductImage = styled.img`
  border-radius: 0.75rem;
  width: 100%;
`;

const ProductInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const ProductTitle = styled.h1`
  font-size: 1.875rem;
  font-weight: 600;
  margin: 0;
`;

const ProductDescription = styled.p`
  color: #9ca3af;
  margin-top: 0.5rem;
`;

const ProductActions = styled.div`
  margin-top: 1.5rem;
  display: flex;
  gap: 1rem;
  align-items: center;
`;

const ProductPrice = styled.span`
  font-size: 1.25rem;
`;

const BuyButton = styled.button`
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  background: linear-gradient(to right, #00f7d2, #5ce9ff);
  border: none;
  color: black;
  font-weight: 500;
  cursor: pointer;
  transition: opacity 0.2s;
  
  &:hover {
    opacity: 0.9;
  }
`;

const ProductView = ({ product, onBack }) => {
  const history = useHistory();

  const handleBuyNow = () => {
    if (product.originalData?._id) {
      history.push(`/productdetails?id=${product.originalData._id}`);
    }
  };

  return (
    <PageContainer>
      <BackButton onClick={onBack}>← Back to Store</BackButton>
      <ProductGrid>
        <ProductImage
          src={product.image}
          alt={product.name}
          onError={(e) => {
            e.target.src = 'https://images.unsplash.com/photo-1584017911766-d451b3d0e843';
          }}
        />
        <ProductInfo>
          <ProductTitle>{product.name}</ProductTitle>
          <ProductDescription>
            Certified pharmaceutical product with full traceability.
          </ProductDescription>
          <ProductActions>
            <ProductPrice>€{product.price} / unit</ProductPrice>
            <BuyButton onClick={handleBuyNow}>
              Buy Now
            </BuyButton>
          </ProductActions>
        </ProductInfo>
      </ProductGrid>
    </PageContainer>
  );
};

export default ProductView;
